import { render } from "./MobileLikeNavHeader.vue?vue&type=template&id=4b3dc134&scoped=true&ts=true"
import script from "./MobileLikeNavHeader.vue?vue&type=script&lang=ts"
export * from "./MobileLikeNavHeader.vue?vue&type=script&lang=ts"

import "./MobileLikeNavHeader.vue?vue&type=style&index=0&id=4b3dc134&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3dc134"]])

export default __exports__